// @flow
import * as React from 'react';
import {
  useFollowUpsFutureQuery,
  useMissedAppsTagId,
} from '../../../../shared';
import { keycloak } from '@coverright/shared/keycloak';
import { FollowUps } from './follow-ups';
import { useParams } from 'react-router-dom';

export const FutureFollowUps = () => {
  const missingAppsTagId = useMissedAppsTagId();
  const {agentId} = useParams<{ agentId?: string }>();

  if (!missingAppsTagId) {
    return null;
  }

  return (
    <FollowUps suffix={'Future'}
               title={'Future Follow-Ups'}
               dataSource={useFollowUpsFutureQuery}
               excludedTagsIds={[missingAppsTagId]}
               agent={agentId || keycloak?.tokenParsed?.sub} />
  );
};
